import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_adjustable_equipment_accommodate_ind_worker_needs_provided'

export const dataPointDefinition = {
  retracedId: 'no_adjustable_equipment_accommodate_ind_worker_needs_provided',
  name: 'No adjustable equipment to accommodate individual worker needs provided by the facility',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-wor-49x',
      number: 'HS-WOR-23-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-44',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[3],hs-33,Yes',
      machineShowHide: '[3],hs-33,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-49x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31900,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
